import { useTheme } from '../../hooks/useTheme';
import type { ThemePref } from '../../hooks/useTheme';

const OPTIONS: Array<{ value: ThemePref; label: string; icon: string; hint: string }> = [
  { value: 'light',  label: 'Light',  icon: '☀', hint: 'Always light' },
  { value: 'dark',   label: 'Dark',   icon: '🌙', hint: 'Always dark' },
  { value: 'system', label: 'System', icon: '🖥', hint: 'Match your device' },
];

export default function AppearanceTab() {
  const { pref, setTheme } = useTheme();

  return (
    <div style={{ padding: '20px 24px', overflowY: 'auto' }}>
      <div style={{ fontSize: '0.88rem', fontWeight: 600, color: 'var(--shell-text)' }}>Theme</div>
      <div style={{ fontSize: '0.78rem', color: 'var(--shell-muted)', marginTop: 4, marginBottom: 16 }}>
        Choose how Relay looks on this device. This preference is saved to this browser only.
      </div>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        {OPTIONS.map((opt) => {
          const active = pref === opt.value;
          return (
            <button
              key={opt.value}
              onClick={() => setTheme(opt.value)}
              style={{
                flex: '1 1 120px', minWidth: 110,
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
                padding: '16px 12px', borderRadius: 8, cursor: 'pointer',
                background: active ? 'var(--active-bg)' : 'rgba(255,255,255,.04)',
                border: `1px solid ${active ? 'var(--active-border)' : 'var(--shell-border)'}`,
                transition: 'all .12s',
              }}
            >
              <span style={{ fontSize: '1.4rem' }}>{opt.icon}</span>
              <span style={{ fontSize: '0.85rem', fontWeight: 600, color: active ? 'var(--v2)' : 'var(--shell-text)' }}>
                {opt.label}
              </span>
              <span style={{ fontSize: '0.7rem', color: 'var(--shell-xs)' }}>{opt.hint}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
